export const setupLazyLoadImage = (emblaApi, preloadAhead = 1) => {
    const imagesLoaded = new Set();
    const slideNodes = emblaApi.slideNodes();
    const imageNodes = slideNodes.map((slideNode) =>
        slideNode.querySelector('[data-src]')
    );
    const slideCount = slideNodes.length;
    const normalizeIndex = (index) => {
            if (!emblaApi.internalEngine().options.loop) return index;

            return ((index % slideCount) + slideCount) % slideCount;
    };

    const loadImage = (index) => {
            index = normalizeIndex(index);

            if (imagesLoaded.has(index)) return;

            const imageNode = imageNodes[index];
            if (!imageNode) return;

            const slideNode = slideNodes[index];
            const src = imageNode.getAttribute('data-src');

            if (!src) return;

            imageNode.src = src;
            imagesLoaded.add(index);

            const onLoad = () => {
                slideNode.classList.add('embla__lazy-load--has-loaded');
                imageNode.removeEventListener('load', onLoad);
            };

            imageNode.addEventListener('load', onLoad);
    };

    const loadImagesInView = () => {
            const inView = emblaApi.slidesInView();

            inView.forEach(loadImage);

            inView.forEach((index) => {
                for (let i = 1; i <= preloadAhead; i++) {
                    loadImage(index + i);
                }
            });

            return imagesLoaded.size === imageNodes.length;
    };

    const loadImagesInViewAndDestroyIfDone = (emblaApi, eventName) => {
            const loadedAll = loadImagesInView();

            if (loadedAll) {
                emblaApi.off(eventName, loadImagesInViewAndDestroyIfDone);
            }
    };

    return loadImagesInViewAndDestroyIfDone;
};
